import { authHeader } from '@/_helpers';
import {userService} from "@/_services/user.service";
import {API_URL} from "../config/app";

const URL = API_URL

export const paymentService = {
  getAllCards,
  addCard,
  updateCard,
  deleteCard
}

function getAllCards() {

  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  return fetch(URL + "/users/payments/cards", requestOptions)
    .then(handleResponse)
    .then(response => {

      let data = [];
      response.data.forEach(resp => {
        data.push(resp);
      })

      return Promise.resolve({data})
    })

}

function addCard(tokenId) {
  let formData = new FormData()
  formData.append("tokenId", tokenId);

  let headers = authHeader();
  delete headers['Content-Type']

  const requestOptions = {
    method: 'POST',
    headers: headers,
    body: formData
  };

  return fetch(URL + "/users/payments/cards", requestOptions).then(handleResponse)
}

function updateCard(cardId, defaultStatus = true) {
  let formData = new FormData()
  formData.append("cardId", cardId);
  formData.append("default", defaultStatus);

  let headers = authHeader();
  delete headers['Content-Type']

  const requestOptions = {
    method: 'PATCH',
    headers: headers,
    body: formData
  };

  return fetch(URL + "/users/payments/cards", requestOptions).then(handleResponse);
}

function deleteCard(cardId) {
  let formData = new FormData()
  formData.append("cardId", cardId);

  let headers = authHeader();
  delete headers['Content-Type']

  const requestOptions = {
    method: 'DELETE',
    headers: headers,
    body: formData
  };

  return fetch(URL + "/users/payments/cards", requestOptions).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.refreshToken();
        return Promise.reject("Intentando recuperar la sesión");
      }

      const error = (data && data.errors[0].detail) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
